import { useEffect, useState } from "react";
import { BriefcaseBusiness, ChevronRight, FolderOpen, Plus, UserMinus } from "lucide-react";
import { call, compact, date, formatError } from "@/lib/api";
import { Modal, PageHeader } from "@/components/common";

export function ProjectManpowerPanel({ projectId, toast, canManage, compactView = false }) {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ manpower_id: "", start_date: "", notes: "" });
  const load = () => call.get(`/manpower/projects/${projectId}`).then(setD).catch(() => {});
  useEffect(() => { load(); }, [projectId]); // eslint-disable-line react-hooks/exhaustive-deps
  const assign = async () => { try { await call.post(`/manpower/projects/${projectId}/assign`, form); setOpen(false); setForm({ manpower_id: "", start_date: "", notes: "" }); load(); toast("Tukang ditambahkan ke project"); } catch (e) { toast(formatError(e), "error"); } };
  const end = async (a) => { if (!window.confirm(`Akhiri penempatan ${a.manpower.name} di project ini? Histori tetap tersimpan.`)) return; try { await call.post(`/manpower/projects/${projectId}/assignments/${a.id}/end`, {}); load(); toast("Penempatan diakhiri"); } catch (e) { toast(formatError(e), "error"); } };
  if (!d) return <div className="panel" style={{ padding: 16 }}><small className="muted">Memuat man power…</small></div>;
  return (
    <div className="panel" style={{ padding: 16 }} data-testid={`project-manpower-${projectId}`}>
      <div className="panel-head" style={{ marginBottom: 10 }}>
        <div><span className="eyebrow">RESOURCE</span><h3>Man Power / Tukang <b className="count-badge">{d.active.length}</b></h3></div>
        {canManage && <button className="primary-btn small" data-testid="pm-assign-button" onClick={() => setOpen(true)}><Plus size={14} /> Tambah Tukang</button>}
      </div>
      {d.active.length === 0 && <small className="muted">Belum ada tukang di project ini.</small>}
      <div className="mp-grid">
        {d.active.map((a, i) => (
          <div className="mp-card" key={a.id} data-testid={`pm-active-${i}`}>
            <div><b>{a.manpower.name}</b><small>{a.manpower.skill || "—"} · sejak {date(a.start_date)}</small></div>
            <span className={`status status-${a.manpower.payment_type === "HARIAN" ? "approved" : "quotation"}`}>{a.manpower.payment_type}</span>
            {canManage && <button className="icon-btn" title="Akhiri penempatan" data-testid={`pm-end-${i}`} onClick={() => end(a)}><UserMinus size={14} /></button>}
          </div>
        ))}
      </div>
      {!compactView && d.history.length > 0 && <details style={{ marginTop: 12 }} data-testid="pm-history"><summary style={{ fontSize: 12, cursor: "pointer", color: "#4a5a73" }}>Histori penempatan ({d.history.length})</summary>
        {d.history.map(a => <div key={a.id} className="mp-history-row"><b>{a.manpower.name}</b><span>{date(a.start_date)} — {date(a.end_date)}</span><span className="status status-draft">ENDED</span></div>)}</details>}
      {open && <Modal title={`Tambah Tukang ke ${d.project.name}`} subtitle="Hanya tukang ACTIVE yang belum terdaftar di project ini" onClose={() => setOpen(false)} onSubmit={assign} testid="pm-assign-modal">
        <div className="form-grid">
          <label className="form-full">Tukang<select required data-testid="pm-assign-select" value={form.manpower_id} onChange={e => setForm({ ...form, manpower_id: e.target.value })}>
            <option value="">Pilih tukang</option>{d.available.map(m => <option key={m.id} value={m.id}>{m.name} · {m.skill || "—"} · {m.payment_type}{m.daily_rate ? ` · ${compact(m.daily_rate)}/hari` : ""}</option>)}
          </select></label>
          <label>Mulai<input type="date" data-testid="pm-assign-start" value={form.start_date} onChange={e => setForm({ ...form, start_date: e.target.value })} /></label>
          <label>Catatan<input value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} /></label>
        </div>
      </Modal>}
    </div>
  );
}

export default function ManpowerProjects({ toast, canManage }) {
  const [projects, setProjects] = useState([]);
  const [sel, setSel] = useState(null);
  const load = () => call.get("/manpower/projects").then(setProjects);
  useEffect(() => { load(); }, []);
  if (sel) return (
    <div>
      <button className="ghost-btn" data-testid="pm-back" onClick={() => { setSel(null); load(); }}><ChevronRight size={14} style={{ transform: "rotate(180deg)" }} /> Semua Project</button>
      <div style={{ marginTop: 14 }}><ProjectManpowerPanel projectId={sel.id} toast={toast} canManage={canManage} /></div>
    </div>
  );
  return (
    <div>
      <PageHeader subtitle="Folder man power per project — setiap project memiliki daftar tukang masing-masing; satu tukang dapat dipakai di beberapa project dengan histori penempatan." />
      <div className="mp-folders" data-testid="pm-folders">
        {projects.map((p, i) => (
          <button className="mp-folder" key={p.id} data-testid={`pm-folder-${i}`} onClick={() => setSel(p)}>
            <div className="mp-folder-head"><FolderOpen size={18} /><span className={`status status-${(p.status || "").toLowerCase().replace(" ", "-")}`}>{p.status}</span></div>
            <b>{p.name}</b><small>{p.code} · {p.location || "—"} · PM {p.manager || "—"}</small>
            <div className="mp-folder-stats"><span><strong>{p.count}</strong> tukang</span><span>{p.harian} harian</span><span>{p.borongan} borongan</span></div>
            {p.manpower.length > 0 && <small className="mp-folder-names">{p.manpower.slice(0, 4).map(m => m.name).join(", ")}{p.manpower.length > 4 ? ` +${p.manpower.length - 4}` : ""}</small>}
          </button>
        ))}
        {projects.length === 0 && <div className="empty-module"><p><BriefcaseBusiness size={16} /> Tidak ada project yang dapat Anda akses.</p></div>}
      </div>
    </div>
  );
}
